$(function () {
    $('body').on('click','[js-schedule-reserv]',function(e){
        e.preventDefault();

        if(!$('body').data('is-authenticated')){
            //$(document).trigger('open-auth');
            //return;
        }

        var club_id = $('[js-schedule-choice].is-active').data('id');
        var $this = $(this);
        if(typeof(club_id) === "undefined"){
            club_id = $this.data('club-id');
        }
        var data = {schedule_id: $this.data('id'), club_id: club_id};
        reserve(data, $this);
    }).on('click', '[js-start-reserv]',function (e) {
        e.preventDefault();

        if(!$('body').data('is-authenticated')){
            $(document).trigger('open-auth');
            return;
        }

        var $this = $(this),
            data = {schedule_id: $this.data('id'), club_id: $('[js-schedule-choice].is-active').data('id')};
        doReserve(data, $this)
    });
    function doReserve(data, $elem) {
        if($elem.data('blocked')) return false;
        $elem.data('blocked', true);

        $.post('/schedule/reserve/do/', data, function (data) {
            if(data.trigger){
                $(document).trigger(data.trigger);
            }
            if(data.alert){
                $$.alert(data.alert);
            }
            if(data.html){
                $$.openModal($(data.html));
            }
            if(data.message){
                var timer;
                $('[js-reserve-error]').html('<p>'+data.message+'</p>');
                clearTimeout(timer);
                timer = setTimeout(function () {
                    $('[js-reserve-error]').find('p').slideUp(500, function () {
                        $(this).remove();
                    });
                },4000);
            }
            if(data.btn){
                if(data.btn.text) $('[js-start-reserv]').html(data.btn.text);
                if(data.btn.active === 'off') $('[js-start-reserv]').addClass('disable');
            }

            $elem.data('blocked', false);

        }, 'json');
    }

    function reserve(data, $elem) {
        if($elem.data('blocked')) return false;
        $elem.data('blocked', true);
        let $modal = $$.openModal($('<div class="modal-box__loading"></div>'));

        $.post('/schedule/reserve/', data, function (data) {
            if(data.trigger){
                $(document).trigger(data.trigger);
            }
            if(data.alert){
                $$.alert(data.alert);
            }
            if(data.html){
                $modal
                    .find('.modal-box-content')
                    .html($(data.html));
            }

            $elem.data('blocked', false);
        }, 'json');
    }

});